export const CONSTANTS = {
  // --- ROULETTE GAME CONSTANTS ---

  // Mapping of numbers to their colors. 0 is green.
  NUMBER_COLORS: {
    0: 'green',
    1: 'red', 2: 'black', 3: 'red', 4: 'black', 5: 'red', 6: 'black', 7: 'red', 8: 'black', 9: 'red', 10: 'black',
    11: 'black', 12: 'red', 13: 'black', 14: 'red', 15: 'black', 16: 'red', 17: 'black', 18: 'red', 19: 'red',
    20: 'black', 21: 'red', 22: 'black', 23: 'red', 24: 'black', 25: 'red', 26: 'black', 27: 'red', 28: 'black',
    29: 'black', 30: 'red', 31: 'black', 32: 'red', 33: 'black', 34: 'red', 35: 'black', 36: 'red',
  },

  // Order of numbers on a standard European roulette wheel
  WHEEL_ORDER: [0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26],

  // Available NFT chip values (in $CHIPS)
  CHIP_VALUES: [1, 5, 10, 25, 100, 500],

  // Payout ratios for different bet types
  BET_PAYOUTS: {
    straight: 35, // Single number
    split: 17,    // Two numbers
    street: 11,   // Three numbers (row)
    corner: 8,    // Four numbers
    six_line: 5,  // Six numbers (two rows)
    column: 2,    // Column of 12 numbers
    dozen: 2,     // Dozen (1-12, 13-24, 25-36)
    odd_even: 1,  // Odd or Even
    red_black: 1, // Red or Black
    high_low: 1,  // 1-18 or 19-36
  },

  // --- MOCK USER DATA ---
  MOCK_ACCOUNT: '0x1a2b3c4d5e6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t',
  INITIAL_CHIP_BALANCE: 10000, // in $CHIPS

  // --- ANIMATION CONSTANTS ---
  BALL_ANIMATION_DURATION: 8000, // ms, total duration of ball spin
  BALL_ANIMATION_TOTAL_SPINS: 6, // number of full circles before landing
  BALL_ANIMATION_OFFSET: 45, // px, distance from wheel center to ball center (should be less than wheel radius)
  BALL_IMAGE_SIZE: 24, // px, size of the ball image

  // --- ENHANCED VISUAL CONSTANTS ---
  WHEEL_SIZE_DESKTOP: 500, // px, wheel size on desktop
  WHEEL_SIZE_MOBILE: 350, // px, wheel size on mobile
  WHEEL_SHADOW_BLUR: 30, // px, shadow blur radius
  WHEEL_SHADOW_SPREAD: 5, // px, shadow spread
  BALL_SHADOW_BLUR: 8, // px, ball shadow blur
  BALL_GLOW_SIZE: 4, // px, ball glow effect
  CASINO_LIGHTING_COLOR: '#FFD700', // Gold lighting color
  WHEEL_BORDER_COLOR: '#8B4513', // Brown wood border
  BALL_TRACK_RADIUS_RATIO: 0.85, // Ball track radius as ratio of wheel radius
};
